module.exports = __webpack_public_path__ + "img/glassquality_3.d272ae79.png";